import BaseService from "./BaseService";

export default class BeneficioService extends BaseService {

  constructor(self) {
    super(self);
  }

  GetBeneficiosConcedidos(parameters) {
    return this.ExecutaFetch("/api/Beneficio/GetBeneficiosConcedidos", "POST", parameters);
  }

  GetBeneficiosExcluidos(parameters) {
    return this.ExecutaFetch("/api/Beneficio/GetBeneficiosExcluidos", "POST", parameters);
  }

  GetHistoricoSolicitacaoBolsa(parameters) {
    return this.ExecutaFetch("/api/Beneficio/GetHistoricoSolicitacaoBolsa", "POST", parameters);
  }
}